/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

export const businessRelationshipDtoTypeEnum = {
  AGENT: "AGENT",
  BRAND: "BRAND",
  MANUFACTURER: "MANUFACTURER",
  OTHER: "OTHER",
  RAW_MATERIAL_SUPPLIER: "RAW_MATERIAL_SUPPLIER",
  SUPPLIER: "SUPPLIER",
  TRADER: "TRADER",
} as const

export type BusinessRelationshipDtoTypeEnumKey =
  (typeof businessRelationshipDtoTypeEnum)[keyof typeof businessRelationshipDtoTypeEnum]

export type BusinessRelationshipDto = {
  /**
   * @type boolean
   */
  isActive: boolean
  /**
   * @type string
   */
  supplierCode: string | null
  /**
   * @type string
   */
  type: BusinessRelationshipDtoTypeEnumKey | null
  /**
   * @type array | undefined
   */
  tagNames?: string[]
}
